import InputSettings from '@/models/InputSettings';
import * as ApiIF from '@/models/ApiIF';
import validator from 'validator';

import emojiRegex from 'emoji-regex';

import { ngWords } from './NgWords';

export default class ValidationHelper {
  private static instance: ValidationHelper;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static getInstance(): ValidationHelper {
    if (!ValidationHelper.instance) {
      ValidationHelper.instance = new ValidationHelper();
    }

    return ValidationHelper.instance;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public rules: Record<string, any> = {
    required: (value: string, flag: boolean, child?: boolean, ruby?: boolean) =>
      flag
        ? this.required(value) ||
          (child
            ? ruby
              ? '<ruby><rb>必</rb><rt>かなら</rt></ruby>ず<ruby><rb>入</rb><rt>い</rt></ruby>れてください'
              : '必ず入れてください'
            : '必須項目です')
        : true,
    number: (value: string, flag: boolean, child?: boolean, _ruby?: boolean) =>
      flag ? this.number(value) || (child ? '使える文字は半角すうじです' : '使用可能な文字は半角数字です') : true,
    alphanumeric: (value: string, flag: boolean, child?: boolean, ruby?: boolean) =>
      flag
        ? this.alphanumeric(value) ||
          (child
            ? ruby
              ? '<ruby><rb>使</rb><rt>つか</rt></ruby>える<ruby><rb>文</rb><rt>も</rt></ruby><ruby><rb>字</rb><rt>じ</rt></ruby>は<ruby><rb>半</rb><rt>はん</rt></ruby><ruby><rb>角</rb><rt>かく</rt></ruby>えいすうじです'
              : '使える文字は半角えいすうじです'
            : '使用可能な文字は半角英数字です')
        : true,
    fullWidth: (value: string, flag: boolean, child?: boolean, _ruby?: boolean) =>
      flag ? this.fullWidth(value) || (child ? '使える文字は全角です' : '使用可能な文字は全角です') : true,
    fullWidthKana: (value: string, flag: boolean, child?: boolean, _ruby?: boolean) =>
      flag ? this.fullWidthKana(value) || (child ? '使える文字は全角です' : '使用可能な文字は全角カナです') : true,
    phone: (value: string, flag: boolean, child?: boolean, _ruby?: boolean) =>
      flag
        ? this.phone(value) ||
          (child ? '使える文字は半角数字、- (半角ハイフン)です' : '使用可能な文字は半角数字、- (半角ハイフン)です')
        : true,
    email: (value: string, flag: boolean, child?: boolean, _ruby?: boolean) =>
      flag
        ? this.email(value) || (child ? 'メールアドレスがただしくありません' : 'メールアドレスが正しくありません')
        : true,
    ip: (value: string, flag: boolean, child?: boolean, _ruby?: boolean) =>
      flag
        ? this.ip(value) || (child ? '有効なIPアドレスを入力してください' : '有効なIPアドレスを入力してください')
        : true,
    unsignedFloat: (value: string, flag: boolean, child?: boolean, _ruby?: boolean) =>
      flag
        ? this.unsignedFloat(value) ||
          (child ? '使える文字は半角数字、.(半角ドット）です' : '使用可能な文字は半角数字、.(半角ドット）です')
        : true,
    maxLength: (value: string, length: number, child?: boolean, ruby?: boolean) =>
      this.maxLength(value, length) ||
      (child
        ? ruby
          ? `${length}<ruby><rb>文字</rb><rt>もじ</rt></ruby><ruby><rb>以内</rb><rt>いない</rt></ruby>で<ruby><rb>入力</rb><rt>にゅうりょく</rt></ruby>してください`
          : `${length}文字以内で入力してください`
        : `${length}文字以内で入力してください`),
    minLength: (value: string, length: number, child?: boolean, ruby?: boolean) =>
      this.minLength(value, length) ||
      (child
        ? ruby
          ? `${length}<ruby><rb>文字</rb><rt>もじ</rt></ruby><ruby><rb>以上</rb><rt>いじょう</rt></ruby>で<ruby><rb>入力</rb><rt>にゅうりょく</rt></ruby>してください`
          : `${length}文字以上で入力してください`
        : `${length}文字以上で入力してください`),
    exactLength: (value: string, length: number, child?: boolean, ruby?: boolean) =>
      this.exactLength(value, length) ||
      (child
        ? ruby
          ? `${length}<ruby><rb>文字</rb><rt>もじ</rt></ruby>で<ruby><rb>入力</rb><rt>にゅうりょく</rt></ruby>してください`
          : `${length}文字で入力してください`
        : `${length}文字で入力してください`),
    stringMatch: (inputString: string, compareString: string) => this.stringMatch(inputString, compareString) || ``,
    fullWidthHalfWidthNumber: (value: string, flag: boolean, child?: boolean, _ruby?: boolean) =>
      flag
        ? this.fullWidthHalfWidthNumber(value) || (child ? '使える文字はすうじです' : '使用可能な文字は数字です')
        : true,
    max: (value: number, max: number, child?: boolean, _ruby?: boolean) =>
      this.max(value, max) || (child ? `${max}以内で入力してください` : `${max}以内で入力してください`),
    min: (value: number, min: number, child?: boolean, _ruby?: boolean) =>
      this.min(value, min) || (child ? `${min}以上を入力してください` : `${min}以上を入力してください`),
    checkEmoji: (value: string, flag: boolean, child?: boolean, ruby?: boolean) =>
      flag
        ? this.checkEmoji(value) ||
          (child
            ? ruby
              ? `<ruby><rb>絵文字</rb><rt>えもじ</rt></ruby>は<ruby><rb>入力</rb><rt>にゅうりょく</rt></ruby>できません`
              : `絵文字は入力できません`
            : `絵文字は入力できません`)
        : true,
    checkPassword: (value: string, flag: boolean, child?: boolean, ruby?: boolean) =>
      flag
        ? this.checkPassword(value) ||
          (child
            ? ruby
              ? `<ruby><rb>半角</rb><rt>はんかく</rt></ruby>えいすうじ、8<ruby><rb>文字以上</rb><rt>もじいじょう</rt></ruby>20<ruby><rb>文字以内</rb><rt>もじいない</rt></ruby>で<ruby><rb>入力</rb><rt>にゅうりょく</rt></ruby>してください`
              : `半角えいすうじ、8文字以上20文字以内で入力してください`
            : `半角えいすうじ、8文字以上20文字以内で入力してください`)
        : true,

    checkForbiddenCharacters: (value: string, flag: boolean, child?: boolean, ruby?: boolean) =>
      flag
        ? this.checkForbiddenCharacters(value) ||
          (child
            ? ruby
              ? `<ruby><rb>入力<rt>にゅうりょく</ruby>できない<ruby><rb>文字<rt>もじ</ruby>がふくまれています`
              : `入力できない文字がふくまれています`
            : `入力できない文字がふくまれています`)
        : true,
    checkLoginPassword: (value: string, flag: boolean, child?: boolean, ruby?: boolean) =>
      flag
        ? this.checkLoginPassword(value) ||
          (child
            ? ruby
              ? '<ruby><rb>使</rb><rt>つか</rt></ruby>える<ruby><rb>文</rb><rt>も</rt></ruby><ruby><rb>字</rb><rt>じ</rt></ruby>は<ruby><rb>半</rb><rt>はん</rt></ruby><ruby><rb>角</rb><rt>かく</rt></ruby>えいすうじです'
              : '使える文字は半角えいすうじです'
            : '使用可能な文字は半角英数字です')
        : true,
  };

  public required(inputString: string) {
    return !!inputString;
  }

  public number(inputString: string) {
    if (!inputString) return true;
    const regEx = new RegExp('^\\d+$');
    if (inputString.match(regEx)) {
      return true;
    }
    return false;
  }

  /**
   * 全角文字（マルチバイト文字）をチェックする。
   * @param {string} inputString
   * @returns {boolean} true:エラーなし、false:エラーあり
   */
  public fullWidth(inputString: string) {
    if (!inputString) {
      return true;
    }
    return validator.isMultibyte(inputString) && !validator.isHalfWidth(inputString);
  }

  public fullWidthKana(inputString: string) {
    if (!inputString) return true;
    // /^([ァ-ン]|ー)+$/
    const regEx = new RegExp('^[ァ-ヴー]*$');
    if (inputString.match(regEx)) {
      return true;
    }
    return false;
  }

  public halfWidth(inputString: string) {
    if (!inputString) return true;
    // Unicode : 0x0 ~ 0x80, 0xf8f0, 0xff61 ~ 0xff9f, 0xf8f1 ~ 0xf8f3
    const regEx = new RegExp('^[\u0032-\u0080\uf8f0\uff61-\uff9f\uf8f1-\uf8f3]*$');
    if (inputString.match(regEx)) {
      return true;
    }
    return false;
  }

  public phone(inputString: string) {
    if (!inputString) return true;
    const regEx = new RegExp('^[0-9-]*$');
    if (inputString.match(regEx)) {
      return true;
    }
    return false;
  }

  /**
   * メールアドレスをチェックする。
   * <pre>
   * 以下のチェックを行う。
   * ・RFC5234に準拠した文字列をチェックする
   * ・全角使用のドメインなどが使えなくなるためTLDの必須チェックは外す
   * </pre>
   * @param {string} inputString
   * @returns {boolean} true:未入力またはOK、false:エラーあり
   */
  public email(inputString: string) {
    if (!inputString) {
      return true;
    }
    return validator.isEmail(inputString, { require_tld: false });
  }

  public ip(inputString: string) {
    if (!inputString) return true;
    const regEx = new RegExp('^[0-9]+\\.[0-9]+\\.[0-9]+\\.[0-9]+$');
    if (inputString.match(regEx)) {
      const ipSplit = inputString.split('.');
      for (let i = 0; i < ipSplit.length; i++) {
        if (parseInt(ipSplit[i]) > 255 || parseInt(ipSplit[i]) < 0) {
          return false;
        }
      }
      return true;
    }
    return false;
  }

  public unsignedFloat(inputString: string) {
    if (!inputString) return true;
    const regEx = new RegExp('^[0-9.]*$');
    if (inputString.match(regEx)) {
      return true;
    }
    return false;
  }

  public alphanumeric(inputString: string) {
    if (!inputString) return true;
    const regEx = new RegExp('^[a-zA-Z0-9]*$');
    if (inputString.match(regEx)) {
      return true;
    }
    return false;
  }

  public maxLength(inputString: string, length: number) {
    if (!inputString) return true;
    return inputString.length <= length;
  }

  public minLength(inputString: string, length: number) {
    if (!inputString) return true;
    return inputString.length >= length;
  }

  public stringMatch(inputString: string, compareString: string) {
    if (!inputString && !compareString) return true;
    return inputString === compareString;
  }

  public fullWidthHalfWidthNumber(inputString: string) {
    if (!inputString) return true;
    const regEx = new RegExp('^[0-9０-９]*$');
    if (inputString.match(regEx)) {
      return true;
    }
    return false;
  }

  public max(inputNumber: number, max: number) {
    return inputNumber <= max;
  }

  public min(inputNumber: number, min: number) {
    return inputNumber >= min;
  }

  public exactLength(inputString: string, length: number) {
    if (!inputString) return true;
    return inputString.length === length;
  }

  public regExpMatch(inputString: string, regExp: string) {
    if (!inputString) return true;
    const regEx = new RegExp(regExp);
    if (inputString.match(regEx)) {
      return true;
    }
    return false;
  }

  public ipToNum(ip: string | undefined) {
    if (!ip) return 0;
    return Number(
      ip
        .split('.')
        .map(d => ('000' + d).substr(-3))
        .join('')
    );
  }

  public checkIpRange(ipRuleA: ApiIF.IpRule, ipRuleB: ApiIF.IpRule) {
    if (ipRuleA.start && ipRuleB.start) {
      const ipRuleAStart = this.ipToNum(ipRuleA.start);
      const ipRuleBStart = this.ipToNum(ipRuleB.start);

      let ipRuleAEnd = this.ipToNum(ipRuleA.end);
      let ipRuleBEnd = this.ipToNum(ipRuleB.end);

      if (ipRuleBEnd === 0) {
        ipRuleBEnd = ipRuleBStart;
      }
      if (ipRuleAEnd === 0) {
        ipRuleAEnd = ipRuleAStart;
      }

      return (
        (ipRuleBStart >= ipRuleAStart && ipRuleBStart <= ipRuleAEnd) ||
        (ipRuleBEnd >= ipRuleAStart && ipRuleBEnd <= ipRuleAEnd) ||
        (ipRuleAStart >= ipRuleBStart && ipRuleAStart <= ipRuleBEnd) ||
        (ipRuleAEnd >= ipRuleBStart && ipRuleAEnd <= ipRuleBEnd)
      );
    }
    return false;
  }

  /**
   * 固定IPの範囲チェックする。
   * @param {IpRule} ipRule
   * @returns {boolean} true:エラーなし、false:開始IP＞終了IP
   */
  public ipStartEndFieldCheck(ipRule: ApiIF.IpRule) {
    if (ipRule.end !== '') {
      if (ipRule.start === '') {
        return false;
      }
      if (ipRule.start && ipRule.end) {
        if (this.ipToNum(ipRule.start) > this.ipToNum(ipRule.end)) {
          return false;
        }
      }
    }
    return true;
  }

  public validate(value: string, inputSettings: InputSettings, field: string, child?: boolean, ruby?: boolean) {
    //Validation
    let valid = true;
    const rulesKey = Object.keys(inputSettings[field].rules);
    const rulesValue = Object.values(inputSettings[field].rules);
    const rulesLength = rulesKey.length;

    for (let i = 0; i < rulesLength; i++) {
      const key = rulesKey[i];
      valid = this.rules[key](value, rulesValue[i], child, ruby);
      if (typeof valid === 'string') {
        return valid;
      }
    }
    return valid;
  }

  public getAllErrorMessages(
    value: string,
    inputSettings: InputSettings,
    field: string,
    value2?: string,
    child = false,
    ruby = false
  ) {
    let valid = true;
    let errorMsg = '';
    const rulesKey = Object.keys(inputSettings[field].rules);
    const rulesValue = Object.values(inputSettings[field].rules);
    const rulesLength = rulesKey.length;

    for (let i = 0; i < rulesLength; i++) {
      const key = rulesKey[i];
      valid = this.rules[key](value, rulesValue[i], child, ruby);
      if (typeof valid === 'string') {
        errorMsg += valid;
        continue;
      }
      if (value2 && typeof value2 !== 'undefined') {
        valid = this.rules[key](value2, rulesValue[i], child, ruby);
        if (typeof valid === 'string') {
          errorMsg += valid;
        }
      }
    }
    return errorMsg;
  }

  public validCheck(value: string, inputSettings: InputSettings, field: string) {
    //Validation
    const rulesKey = Object.keys(inputSettings[field].rules);
    const rulesValue = Object.values(inputSettings[field].rules);
    const rulesLength = rulesKey.length;

    for (let i = 0; i < rulesLength; i++) {
      const key = rulesKey[i];
      const errorMsg = this.rules[key](value, rulesValue[i], false);
      if (typeof errorMsg === 'string') {
        return false;
      }
    }
    return true;
  }

  private checkEmoji(inputText: string) {
    if (!inputText) return true;
    const regex = emojiRegex();
    for (const match of inputText.matchAll(regex)) {
      const emoji = match[0];
      if (emoji) return false;
    }
    return true;
  }

  private checkPassword(inputText: string) {
    const minLen = 8;
    const maxLen = 20;

    // 文字数チェック
    if (inputText.length < minLen || maxLen < inputText.length) return false;

    // 使用文字チェック
    const regEx = new RegExp('^[a-zA-Z0-9]*$'); // 半角英数字パターン
    if (!inputText.match(regEx)) return false;

    return true;
  }

  /**
   * 規制文字をチェックする。
   * @param {string} inputText
   * @returns {boolean} true:エラーなし、false:エラーあり
   */
  private checkForbiddenCharacters(inputText: string) {
    if (!inputText) return true;
    // 規制文字リスト
    const forbiddenCharacters = ngWords;

    let result = true;
    // 使用文字チェック
    forbiddenCharacters.forEach(forbiddenCharacter => {
      if (inputText.includes(forbiddenCharacter)) {
        result = false;
      }
    });

    return result;
  }

  /**
   * ログイン時のパスワードをチェックする。
   * 半角英数字と@ を許可する
   * @param {string} inputString
   * @returns {boolean} true:エラーなし、false:エラーあり
   */
  public checkLoginPassword(inputString: string) {
    if (!inputString) {
      return true;
    }

    const regEx = new RegExp('^[a-zA-Z0-9@]*$');
    if (inputString.match(regEx)) {
      return true;
    }
    return false;
  }
}
